// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PurchasePlanReceiptInfo-purchasePlanReceiptBox-OFRld {
    display: grid;
    gap: 24px;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptContainer-O2JOC {
    display: grid;
    grid-template-columns: 588px 1fr;
    gap: 30px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsBox-tj9fF {
    display: grid;
    gap: 30px;
    position: sticky;
    top: 42px;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptBillingContainer-_aEg0 {
    background: var(--secondary-gray-bg);
}

.PurchasePlanReceiptInfo-purchasePlanReceiptInfoBox-qG65a,
.PurchasePlanReceiptInfo-purchasePlanReceiptBillingContainer-_aEg0,
.PurchasePlanReceiptInfo-purchasePlanReceiptPaymentContainer-QNtQ7 {
    border: 1px solid var(--primary-border);
    padding: 24px;
    border-radius: 12px;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptInfoHead-GvT1F {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 18px;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptPlanInfoBox-X8NrH,
.PurchasePlanReceiptInfo-purchasePlansReceiptBenefitsBox-JwWdc {
    border-top: 1px solid var(--primary-border);
    padding-top: 18px;
    margin-top: 18px;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptInfoBadge-N3n9v {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    border: 1px solid var(--primary-border);
    padding: 4px 12px;
    border-radius: 100px;
    background: var(--servicePlan-badge-bg);
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--primary-foreground);
}

.PurchasePlanReceiptInfo-purchasePlanReceiptInfoTitle-avONG,
.PurchasePlanReceiptInfo-purchasePlanReceiptInfoSubTitle-d2X7w,
.PurchasePlanReceiptInfo-purchasePlanReceiptInfoDesc-u5bQU {
    color: var(--primary-foreground);
}

.PurchasePlanReceiptInfo-purchasePlanReceiptInfoTitle-avONG {
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 12px;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptInfoSubTitle-d2X7w {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 0;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptInfoDesc-u5bQU,
.PurchasePlanReceiptInfo-purchasePlanReceiptBottomCaption-d_vmC {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    margin-bottom: 0;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptSpecialText-WCMCC {
    font-weight: 600;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptPlanDesc-kMbT9 {
    margin-top: 6px;
    white-space: pre-line;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptBenefitsList-LldxC {
    display: grid;
    gap: 12px;
    margin-top: 12px;
}

.PurchasePlanReceiptInfo-purchasePlansReceiptBenefitsFeature-m2X7N {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 4px;
}

.PurchasePlanReceiptInfo-purchasePlansReceiptBenefitsFeature-m2X7N svg {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsList-OPOKv {
    display: grid;
    gap: 12px;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsItem-MzSiY {
    display: grid;
    grid-template-columns: 2fr 1fr;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsTitle-Kwf0t {
    text-align: start;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsAmount-bZnlC {
    text-align: end;
}

.PurchasePlanReceiptInfo-purchasePlanReceiptLabel-iRjUk {
    display: inline-block;
}

@media (max-width: 1199px) and (min-width: 992px) {
    .PurchasePlanReceiptInfo-purchasePlanReceiptContainer-O2JOC {
        grid-template-columns: 520px 1fr;
    }
}

@media (max-width: 991px) {
    .PurchasePlanReceiptInfo-purchasePlanReceiptContainer-O2JOC {
        grid-template-columns: 100%;
    }

    .PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsBox-tj9fF {
        gap: 24px;
    }
}

@media (max-width: 767px) {

    .PurchasePlanReceiptInfo-purchasePlanReceiptInfoBox-qG65a,
    .PurchasePlanReceiptInfo-purchasePlanReceiptBillingContainer-_aEg0,
    .PurchasePlanReceiptInfo-purchasePlanReceiptPaymentContainer-QNtQ7 {
        padding: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ServicePlanContainer/PurchasePlanReceiptInfo/PurchasePlanReceiptInfo.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,uCAAuC;IACvC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;AAClC;;AAEA;;IAEI,2CAA2C;IAC3C,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oBAAc;QAAd,cAAc;IACd,uCAAuC;IACvC,iBAAiB;IACjB,oBAAoB;IACpB,uCAAuC;IACvC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;;IAEI;;;QAGI,aAAa;IACjB;AACJ","sourcesContent":[".purchasePlanReceiptBox {\n    display: grid;\n    gap: 24px;\n}\n\n.purchasePlanReceiptContainer {\n    display: grid;\n    grid-template-columns: 588px 1fr;\n    gap: 30px;\n    align-items: flex-start;\n}\n\n.purchasePlanReceiptPricingDetailsBox {\n    display: grid;\n    gap: 30px;\n    position: sticky;\n    top: 42px;\n}\n\n.purchasePlanReceiptBillingContainer {\n    background: var(--secondary-gray-bg);\n}\n\n.purchasePlanReceiptInfoBox,\n.purchasePlanReceiptBillingContainer,\n.purchasePlanReceiptPaymentContainer {\n    border: 1px solid var(--primary-border);\n    padding: 24px;\n    border-radius: 12px;\n}\n\n.purchasePlanReceiptInfoHead {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n    justify-content: space-between;\n}\n\n.purchasePlanReceiptPlanInfoBox,\n.purchasePlansReceiptBenefitsBox {\n    border-top: 1px solid var(--primary-border);\n    padding-top: 18px;\n    margin-top: 18px;\n}\n\n.purchasePlanReceiptInfoBadge {\n    flex-shrink: 0;\n    border: 1px solid var(--primary-border);\n    padding: 4px 12px;\n    border-radius: 100px;\n    background: var(--servicePlan-badge-bg);\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n}\n\n.purchasePlanReceiptInfoTitle,\n.purchasePlanReceiptInfoSubTitle,\n.purchasePlanReceiptInfoDesc {\n    color: var(--primary-foreground);\n}\n\n.purchasePlanReceiptInfoTitle {\n    font-size: 24px;\n    line-height: 30px;\n    font-weight: 600;\n    margin-top: 0;\n    margin-bottom: 12px;\n}\n\n.purchasePlanReceiptInfoSubTitle {\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 600;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.purchasePlanReceiptInfoDesc,\n.purchasePlanReceiptBottomCaption {\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n    margin-bottom: 0;\n}\n\n.purchasePlanReceiptSpecialText {\n    font-weight: 600;\n}\n\n.purchasePlanReceiptPlanDesc {\n    margin-top: 6px;\n    white-space: pre-line;\n}\n\n.purchasePlanReceiptBenefitsList {\n    display: grid;\n    gap: 12px;\n    margin-top: 12px;\n}\n\n.purchasePlansReceiptBenefitsFeature {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.purchasePlansReceiptBenefitsFeature svg {\n    flex-shrink: 0;\n}\n\n.purchasePlanReceiptPricingDetailsList {\n    display: grid;\n    gap: 12px;\n}\n\n.purchasePlanReceiptPricingDetailsItem {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    align-items: center;\n}\n\n.purchasePlanReceiptPricingDetailsTitle {\n    text-align: start;\n}\n\n.purchasePlanReceiptPricingDetailsAmount {\n    text-align: end;\n}\n\n.purchasePlanReceiptLabel {\n    display: inline-block;\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .purchasePlanReceiptContainer {\n        grid-template-columns: 520px 1fr;\n    }\n}\n\n@media (max-width: 991px) {\n    .purchasePlanReceiptContainer {\n        grid-template-columns: 100%;\n    }\n\n    .purchasePlanReceiptPricingDetailsBox {\n        gap: 24px;\n    }\n}\n\n@media (max-width: 767px) {\n\n    .purchasePlanReceiptInfoBox,\n    .purchasePlanReceiptBillingContainer,\n    .purchasePlanReceiptPaymentContainer {\n        padding: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"purchasePlanReceiptBox": `PurchasePlanReceiptInfo-purchasePlanReceiptBox-OFRld`,
	"purchasePlanReceiptContainer": `PurchasePlanReceiptInfo-purchasePlanReceiptContainer-O2JOC`,
	"purchasePlanReceiptPricingDetailsBox": `PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsBox-tj9fF`,
	"purchasePlanReceiptBillingContainer": `PurchasePlanReceiptInfo-purchasePlanReceiptBillingContainer-_aEg0`,
	"purchasePlanReceiptInfoBox": `PurchasePlanReceiptInfo-purchasePlanReceiptInfoBox-qG65a`,
	"purchasePlanReceiptPaymentContainer": `PurchasePlanReceiptInfo-purchasePlanReceiptPaymentContainer-QNtQ7`,
	"purchasePlanReceiptInfoHead": `PurchasePlanReceiptInfo-purchasePlanReceiptInfoHead-GvT1F`,
	"purchasePlanReceiptPlanInfoBox": `PurchasePlanReceiptInfo-purchasePlanReceiptPlanInfoBox-X8NrH`,
	"purchasePlansReceiptBenefitsBox": `PurchasePlanReceiptInfo-purchasePlansReceiptBenefitsBox-JwWdc`,
	"purchasePlanReceiptInfoBadge": `PurchasePlanReceiptInfo-purchasePlanReceiptInfoBadge-N3n9v`,
	"purchasePlanReceiptInfoTitle": `PurchasePlanReceiptInfo-purchasePlanReceiptInfoTitle-avONG`,
	"purchasePlanReceiptInfoSubTitle": `PurchasePlanReceiptInfo-purchasePlanReceiptInfoSubTitle-d2X7w`,
	"purchasePlanReceiptInfoDesc": `PurchasePlanReceiptInfo-purchasePlanReceiptInfoDesc-u5bQU`,
	"purchasePlanReceiptBottomCaption": `PurchasePlanReceiptInfo-purchasePlanReceiptBottomCaption-d_vmC`,
	"purchasePlanReceiptSpecialText": `PurchasePlanReceiptInfo-purchasePlanReceiptSpecialText-WCMCC`,
	"purchasePlanReceiptPlanDesc": `PurchasePlanReceiptInfo-purchasePlanReceiptPlanDesc-kMbT9`,
	"purchasePlanReceiptBenefitsList": `PurchasePlanReceiptInfo-purchasePlanReceiptBenefitsList-LldxC`,
	"purchasePlansReceiptBenefitsFeature": `PurchasePlanReceiptInfo-purchasePlansReceiptBenefitsFeature-m2X7N`,
	"purchasePlanReceiptPricingDetailsList": `PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsList-OPOKv`,
	"purchasePlanReceiptPricingDetailsItem": `PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsItem-MzSiY`,
	"purchasePlanReceiptPricingDetailsTitle": `PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsTitle-Kwf0t`,
	"purchasePlanReceiptPricingDetailsAmount": `PurchasePlanReceiptInfo-purchasePlanReceiptPricingDetailsAmount-bZnlC`,
	"purchasePlanReceiptLabel": `PurchasePlanReceiptInfo-purchasePlanReceiptLabel-iRjUk`
};
module.exports = ___CSS_LOADER_EXPORT___;
